import { useQuery } from "wasp/client/operations";
import { getStudentMentorNotes } from "wasp/client/operations";
import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";
import { Card, CardContent } from "../../../client/components/ui/card";
import { CardSectionHeader } from "../../../client/components/ui/card-section-header";
import { useDashboardData } from "../DashboardDataContext";
import { useLanguageContext } from "../../../client/contexts/LanguageContext";

export default function MentorNotesWidget() {
  const { t } = useDashboardData();
  const { language } = useLanguageContext();

  const { data: notes = [], isLoading } = useQuery(getStudentMentorNotes, { isGlobal: true });

  return (
    <Card className="h-full flex flex-col overflow-hidden">
      <CardSectionHeader label={t.dashboard.widgets.mentorNotes} isDark={false} compact />
      <CardContent className="p-0 flex-1 overflow-y-auto">
        {isLoading ? (
          <div className="px-4 py-6 text-center text-sm text-muted-foreground">
            {"..."}
          </div>
        ) : (notes as any[]).length === 0 ? (
          <div className="px-4 py-6 text-center text-sm text-muted-foreground">
            {t.dashboard.widgets.mentorNotesEmpty}
          </div>
        ) : (
          <ul className="divide-y divide-border/30">
            {(notes as any[]).map((note: any) => {
              const mentorName =
                [note.mentor?.firstName, note.mentor?.lastName].filter(Boolean).join(" ") ||
                note.mentor?.email ||
                "—";
              return (
                <li key={note.id} className="px-4 py-3 flex flex-col gap-1">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-xs font-medium text-primary truncate">{mentorName}</span>
                    <span className="text-[11px] text-muted-foreground whitespace-nowrap shrink-0">
                      {formatDistanceToNow(new Date(note.createdAt), {
                        addSuffix: true,
                        locale: language === "fr" ? fr : undefined,
                      })}
                    </span>
                  </div>
                  <p className="text-sm text-foreground whitespace-pre-wrap leading-relaxed">
                    {note.content}
                  </p>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
